/* tslint:disable */
/* eslint-disable */
/**
 * InnerAnalytics MNT Server
 * InnerAnalytics MNT server API specification.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AuthEmailStartRequest } from '../models';
// @ts-ignore
import { AuthEmailVerifyRequest } from '../models';
// @ts-ignore
import { AuthEmailVerifyResponse } from '../models';
// @ts-ignore
import { AuthRegionLookupRequest } from '../models';
// @ts-ignore
import { AuthRegionLookupResponse } from '../models';
// @ts-ignore
import { ExternalOauthTokenFlowAuthorization } from '../models';
// @ts-ignore
import { UserAuthorizationResponse } from '../models';
/**
 * OauthApi - axios parameter creator
 * @export
 */
export const OauthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Unauthenticated and rate limited per client address and per email. Always returns 202 with an empty body for any email. The home region emails a login verification code to registered patients, a signup verification code to invited patients, or a generic no-account message otherwise. Canada forwards a US-home reservation to the US internal start endpoint and still returns 202 if that call fails. Account state is only revealed by POST /auth/email/verify. 
         * @summary Start verified email entry for login or signup
         * @param {AuthEmailStartRequest} AuthEmailStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAuthEmailStartAuthEmail: async (AuthEmailStartRequest: AuthEmailStartRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'AuthEmailStartRequest' is not null or undefined
            assertParamExists('appApiAuthEmailStartAuthEmail', 'AuthEmailStartRequest', AuthEmailStartRequest)
            const localVarPath = `/auth/email/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AuthEmailStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unauthenticated and rate limited. On success returns whether the email is registered (continue to password / MFA) or invited (signup prefill). Wrong, expired, replaced, used, or locked codes return the same 400. Does not consume invited codes; POST /patients/onboarding does. Canada forwards a US-home reservation to the US internal verify endpoint and returns that body. A failed forward is the same 400 as a wrong code. 
         * @summary Verify emailed code and return account state
         * @param {AuthEmailVerifyRequest} AuthEmailVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAuthEmailVerifyAuthEmail: async (AuthEmailVerifyRequest: AuthEmailVerifyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'AuthEmailVerifyRequest' is not null or undefined
            assertParamExists('appApiAuthEmailVerifyAuthEmail', 'AuthEmailVerifyRequest', AuthEmailVerifyRequest)
            const localVarPath = `/auth/email/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AuthEmailVerifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hash-only discovery hop for shared-app login. Clients send HMAC-SHA256 hex of the normalized email. A US reservation returns region=us. A miss returns region=ca. Never send raw email. Does not return a URL. 
         * @summary Discover API region from a peppered email hash
         * @param {AuthRegionLookupRequest} AuthRegionLookupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAuthRegionLookupRegion: async (AuthRegionLookupRequest: AuthRegionLookupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'AuthRegionLookupRequest' is not null or undefined
            assertParamExists('appApiAuthRegionLookupRegion', 'AuthRegionLookupRequest', AuthRegionLookupRequest)
            const localVarPath = `/auth/region`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AuthRegionLookupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a URL that authorizes a new third-party OAuth flow
         * @param {string} [provider_name] 
         * @param {string} [provider_endpoint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiExternalOauthGetAuthorizationUrl: async (provider_name?: string, provider_endpoint?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/current/external_oauth_authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (provider_name !== undefined) {
                localVarQueryParameter['provider_name'] = provider_name;
            }

            if (provider_endpoint !== undefined) {
                localVarQueryParameter['provider_endpoint'] = provider_endpoint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get auth token (with mfa support)
         * @param {string} username 
         * @param {string} password 
         * @param {string} response_type indicate token here
         * @param {string} client_id 
         * @param {string} redirect_uri 
         * @param {string} [token] mfa token
         * @param {string} [user_scope] user scope, either patient or reviewer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiOauthAuthorize: async (username: string, password: string, response_type: string, client_id: string, redirect_uri: string, token?: string, user_scope?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('appApiOauthAuthorize', 'username', username)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('appApiOauthAuthorize', 'password', password)
            // verify required parameter 'response_type' is not null or undefined
            assertParamExists('appApiOauthAuthorize', 'response_type', response_type)
            // verify required parameter 'client_id' is not null or undefined
            assertParamExists('appApiOauthAuthorize', 'client_id', client_id)
            // verify required parameter 'redirect_uri' is not null or undefined
            assertParamExists('appApiOauthAuthorize', 'redirect_uri', redirect_uri)
            const localVarPath = `/oauth/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (username !== undefined) { 
                localVarFormParams.set('username', username as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (token !== undefined) { 
                localVarFormParams.set('token', token as any);
            }
    
            if (response_type !== undefined) { 
                localVarFormParams.set('response_type', response_type as any);
            }
    
            if (client_id !== undefined) { 
                localVarFormParams.set('client_id', client_id as any);
            }
    
            if (redirect_uri !== undefined) { 
                localVarFormParams.set('redirect_uri', redirect_uri as any);
            }
    
            if (user_scope !== undefined) { 
                localVarFormParams.set('user_scope', user_scope as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Temporary token for clinician <> auditor authentication
         * @param {string} [token] 
         * @param {string} [response_type] indicate token here
         * @param {string} [client_id] 
         * @param {string} [redirect_uri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiOauthAuthorizeAuditorToken: async (token?: string, response_type?: string, client_id?: string, redirect_uri?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/oauth/authorize_auditor_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (token !== undefined) { 
                localVarFormParams.set('token', token as any);
            }
    
            if (response_type !== undefined) { 
                localVarFormParams.set('response_type', response_type as any);
            }
    
            if (client_id !== undefined) { 
                localVarFormParams.set('client_id', client_id as any);
            }
    
            if (redirect_uri !== undefined) { 
                localVarFormParams.set('redirect_uri', redirect_uri as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get auth token using a secure token
         * @param {string} secure_token 
         * @param {string} response_type indicate token here
         * @param {string} client_id 
         * @param {string} redirect_uri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiOauthAuthorizeMagicLink: async (secure_token: string, response_type: string, client_id: string, redirect_uri: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'secure_token' is not null or undefined
            assertParamExists('appApiOauthAuthorizeMagicLink', 'secure_token', secure_token)
            // verify required parameter 'response_type' is not null or undefined
            assertParamExists('appApiOauthAuthorizeMagicLink', 'response_type', response_type)
            // verify required parameter 'client_id' is not null or undefined
            assertParamExists('appApiOauthAuthorizeMagicLink', 'client_id', client_id)
            // verify required parameter 'redirect_uri' is not null or undefined
            assertParamExists('appApiOauthAuthorizeMagicLink', 'redirect_uri', redirect_uri)
            const localVarPath = `/oauth/authorize_magic_link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (secure_token !== undefined) { 
                localVarFormParams.set('secure_token', secure_token as any);
            }
    
            if (response_type !== undefined) { 
                localVarFormParams.set('response_type', response_type as any);
            }
    
            if (client_id !== undefined) { 
                localVarFormParams.set('client_id', client_id as any);
            }
    
            if (redirect_uri !== undefined) { 
                localVarFormParams.set('redirect_uri', redirect_uri as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get auth token (to be used from swagger ui)
         * @param {string} username 
         * @param {string} password 
         * @param {string} response_type indicate token here
         * @param {string} client_id 
         * @param {string} redirect_uri 
         * @param {string} [token] mfa token
         * @param {string} [user_scope] user scope, either patient or reviewer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiOauthAuthorizeSwagger: async (username: string, password: string, response_type: string, client_id: string, redirect_uri: string, token?: string, user_scope?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('appApiOauthAuthorizeSwagger', 'username', username)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('appApiOauthAuthorizeSwagger', 'password', password)
            // verify required parameter 'response_type' is not null or undefined
            assertParamExists('appApiOauthAuthorizeSwagger', 'response_type', response_type)
            // verify required parameter 'client_id' is not null or undefined
            assertParamExists('appApiOauthAuthorizeSwagger', 'client_id', client_id)
            // verify required parameter 'redirect_uri' is not null or undefined
            assertParamExists('appApiOauthAuthorizeSwagger', 'redirect_uri', redirect_uri)
            const localVarPath = `/oauth/authorize_swagger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (username !== undefined) { 
                localVarFormParams.set('username', username as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (token !== undefined) { 
                localVarFormParams.set('token', token as any);
            }
    
            if (response_type !== undefined) { 
                localVarFormParams.set('response_type', response_type as any);
            }
    
            if (client_id !== undefined) { 
                localVarFormParams.set('client_id', client_id as any);
            }
    
            if (redirect_uri !== undefined) { 
                localVarFormParams.set('redirect_uri', redirect_uri as any);
            }
    
            if (user_scope !== undefined) { 
                localVarFormParams.set('user_scope', user_scope as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout and invalidate the current oauth token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiOauthLogout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/oauth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OauthApi - functional programming interface
 * @export
 */
export const OauthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OauthApiAxiosParamCreator(configuration)
    return {
        /**
         * Unauthenticated and rate limited per client address and per email. Always returns 202 with an empty body for any email. The home region emails a login verification code to registered patients, a signup verification code to invited patients, or a generic no-account message otherwise. Canada forwards a US-home reservation to the US internal start endpoint and still returns 202 if that call fails. Account state is only revealed by POST /auth/email/verify. 
         * @summary Start verified email entry for login or signup
         * @param {AuthEmailStartRequest} AuthEmailStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiAuthEmailStartAuthEmail(AuthEmailStartRequest: AuthEmailStartRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiAuthEmailStartAuthEmail(AuthEmailStartRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unauthenticated and rate limited. On success returns whether the email is registered (continue to password / MFA) or invited (signup prefill). Wrong, expired, replaced, used, or locked codes return the same 400. Does not consume invited codes; POST /patients/onboarding does. Canada forwards a US-home reservation to the US internal verify endpoint and returns that body. A failed forward is the same 400 as a wrong code. 
         * @summary Verify emailed code and return account state
         * @param {AuthEmailVerifyRequest} AuthEmailVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiAuthEmailVerifyAuthEmail(AuthEmailVerifyRequest: AuthEmailVerifyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthEmailVerifyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiAuthEmailVerifyAuthEmail(AuthEmailVerifyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Hash-only discovery hop for shared-app login. Clients send HMAC-SHA256 hex of the normalized email. A US reservation returns region=us. A miss returns region=ca. Never send raw email. Does not return a URL. 
         * @summary Discover API region from a peppered email hash
         * @param {AuthRegionLookupRequest} AuthRegionLookupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiAuthRegionLookupRegion(AuthRegionLookupRequest: AuthRegionLookupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthRegionLookupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiAuthRegionLookupRegion(AuthRegionLookupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a URL that authorizes a new third-party OAuth flow
         * @param {string} [provider_name] 
         * @param {string} [provider_endpoint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiExternalOauthGetAuthorizationUrl(provider_name?: string, provider_endpoint?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalOauthTokenFlowAuthorization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiExternalOauthGetAuthorizationUrl(provider_name, provider_endpoint, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get auth token (with mfa support)
         * @param {string} username 
         * @param {string} password 
         * @param {string} response_type indicate token here
         * @param {string} client_id 
         * @param {string} redirect_uri 
         * @param {string} [token] mfa token
         * @param {string} [user_scope] user scope, either patient or reviewer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiOauthAuthorize(username: string, password: string, response_type: string, client_id: string, redirect_uri: string, token?: string, user_scope?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiOauthAuthorize(username, password, response_type, client_id, redirect_uri, token, user_scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Temporary token for clinician <> auditor authentication
         * @param {string} [token] 
         * @param {string} [response_type] indicate token here
         * @param {string} [client_id] 
         * @param {string} [redirect_uri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiOauthAuthorizeAuditorToken(token?: string, response_type?: string, client_id?: string, redirect_uri?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiOauthAuthorizeAuditorToken(token, response_type, client_id, redirect_uri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get auth token using a secure token
         * @param {string} secure_token 
         * @param {string} response_type indicate token here
         * @param {string} client_id 
         * @param {string} redirect_uri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiOauthAuthorizeMagicLink(secure_token: string, response_type: string, client_id: string, redirect_uri: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiOauthAuthorizeMagicLink(secure_token, response_type, client_id, redirect_uri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get auth token (to be used from swagger ui)
         * @param {string} username 
         * @param {string} password 
         * @param {string} response_type indicate token here
         * @param {string} client_id 
         * @param {string} redirect_uri 
         * @param {string} [token] mfa token
         * @param {string} [user_scope] user scope, either patient or reviewer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiOauthAuthorizeSwagger(username: string, password: string, response_type: string, client_id: string, redirect_uri: string, token?: string, user_scope?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiOauthAuthorizeSwagger(username, password, response_type, client_id, redirect_uri, token, user_scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logout and invalidate the current oauth token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiOauthLogout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiOauthLogout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OauthApi - factory interface
 * @export
 */
export const OauthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OauthApiFp(configuration)
    return {
        /**
         * Unauthenticated and rate limited per client address and per email. Always returns 202 with an empty body for any email. The home region emails a login verification code to registered patients, a signup verification code to invited patients, or a generic no-account message otherwise. Canada forwards a US-home reservation to the US internal start endpoint and still returns 202 if that call fails. Account state is only revealed by POST /auth/email/verify. 
         * @summary Start verified email entry for login or signup
         * @param {AuthEmailStartRequest} AuthEmailStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAuthEmailStartAuthEmail(AuthEmailStartRequest: AuthEmailStartRequest, options?: any): AxiosPromise<void> {
            return localVarFp.appApiAuthEmailStartAuthEmail(AuthEmailStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Unauthenticated and rate limited. On success returns whether the email is registered (continue to password / MFA) or invited (signup prefill). Wrong, expired, replaced, used, or locked codes return the same 400. Does not consume invited codes; POST /patients/onboarding does. Canada forwards a US-home reservation to the US internal verify endpoint and returns that body. A failed forward is the same 400 as a wrong code. 
         * @summary Verify emailed code and return account state
         * @param {AuthEmailVerifyRequest} AuthEmailVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAuthEmailVerifyAuthEmail(AuthEmailVerifyRequest: AuthEmailVerifyRequest, options?: any): AxiosPromise<AuthEmailVerifyResponse> {
            return localVarFp.appApiAuthEmailVerifyAuthEmail(AuthEmailVerifyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Hash-only discovery hop for shared-app login. Clients send HMAC-SHA256 hex of the normalized email. A US reservation returns region=us. A miss returns region=ca. Never send raw email. Does not return a URL. 
         * @summary Discover API region from a peppered email hash
         * @param {AuthRegionLookupRequest} AuthRegionLookupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAuthRegionLookupRegion(AuthRegionLookupRequest: AuthRegionLookupRequest, options?: any): AxiosPromise<AuthRegionLookupResponse> {
            return localVarFp.appApiAuthRegionLookupRegion(AuthRegionLookupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a URL that authorizes a new third-party OAuth flow
         * @param {string} [provider_name] 
         * @param {string} [provider_endpoint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiExternalOauthGetAuthorizationUrl(provider_name?: string, provider_endpoint?: string, options?: any): AxiosPromise<ExternalOauthTokenFlowAuthorization> {
            return localVarFp.appApiExternalOauthGetAuthorizationUrl(provider_name, provider_endpoint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get auth token (with mfa support)
         * @param {string} username 
         * @param {string} password 
         * @param {string} response_type indicate token here
         * @param {string} client_id 
         * @param {string} redirect_uri 
         * @param {string} [token] mfa token
         * @param {string} [user_scope] user scope, either patient or reviewer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiOauthAuthorize(username: string, password: string, response_type: string, client_id: string, redirect_uri: string, token?: string, user_scope?: string, options?: any): AxiosPromise<UserAuthorizationResponse> {
            return localVarFp.appApiOauthAuthorize(username, password, response_type, client_id, redirect_uri, token, user_scope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Temporary token for clinician <> auditor authentication
         * @param {string} [token] 
         * @param {string} [response_type] indicate token here
         * @param {string} [client_id] 
         * @param {string} [redirect_uri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiOauthAuthorizeAuditorToken(token?: string, response_type?: string, client_id?: string, redirect_uri?: string, options?: any): AxiosPromise<void> {
            return localVarFp.appApiOauthAuthorizeAuditorToken(token, response_type, client_id, redirect_uri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get auth token using a secure token
         * @param {string} secure_token 
         * @param {string} response_type indicate token here
         * @param {string} client_id 
         * @param {string} redirect_uri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiOauthAuthorizeMagicLink(secure_token: string, response_type: string, client_id: string, redirect_uri: string, options?: any): AxiosPromise<UserAuthorizationResponse> {
            return localVarFp.appApiOauthAuthorizeMagicLink(secure_token, response_type, client_id, redirect_uri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get auth token (to be used from swagger ui)
         * @param {string} username 
         * @param {string} password 
         * @param {string} response_type indicate token here
         * @param {string} client_id 
         * @param {string} redirect_uri 
         * @param {string} [token] mfa token
         * @param {string} [user_scope] user scope, either patient or reviewer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiOauthAuthorizeSwagger(username: string, password: string, response_type: string, client_id: string, redirect_uri: string, token?: string, user_scope?: string, options?: any): AxiosPromise<string> {
            return localVarFp.appApiOauthAuthorizeSwagger(username, password, response_type, client_id, redirect_uri, token, user_scope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout and invalidate the current oauth token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiOauthLogout(options?: any): AxiosPromise<string> {
            return localVarFp.appApiOauthLogout(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for appApiAuthEmailStartAuthEmail operation in OauthApi.
 * @export
 * @interface OauthApiAppApiAuthEmailStartAuthEmailRequest
 */
export interface OauthApiAppApiAuthEmailStartAuthEmailRequest {
    /**
     * 
     * @type {AuthEmailStartRequest}
     * @memberof OauthApiAppApiAuthEmailStartAuthEmail
     */
    readonly AuthEmailStartRequest: AuthEmailStartRequest
}

/**
 * Request parameters for appApiAuthEmailVerifyAuthEmail operation in OauthApi.
 * @export
 * @interface OauthApiAppApiAuthEmailVerifyAuthEmailRequest
 */
export interface OauthApiAppApiAuthEmailVerifyAuthEmailRequest {
    /**
     * 
     * @type {AuthEmailVerifyRequest}
     * @memberof OauthApiAppApiAuthEmailVerifyAuthEmail
     */
    readonly AuthEmailVerifyRequest: AuthEmailVerifyRequest
}

/**
 * Request parameters for appApiAuthRegionLookupRegion operation in OauthApi.
 * @export
 * @interface OauthApiAppApiAuthRegionLookupRegionRequest
 */
export interface OauthApiAppApiAuthRegionLookupRegionRequest {
    /**
     * 
     * @type {AuthRegionLookupRequest}
     * @memberof OauthApiAppApiAuthRegionLookupRegion
     */
    readonly AuthRegionLookupRequest: AuthRegionLookupRequest
}

/**
 * Request parameters for appApiExternalOauthGetAuthorizationUrl operation in OauthApi.
 * @export
 * @interface OauthApiAppApiExternalOauthGetAuthorizationUrlRequest
 */
export interface OauthApiAppApiExternalOauthGetAuthorizationUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiExternalOauthGetAuthorizationUrl
     */
    readonly provider_name?: string

    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiExternalOauthGetAuthorizationUrl
     */
    readonly provider_endpoint?: string
}

/**
 * Request parameters for appApiOauthAuthorize operation in OauthApi.
 * @export
 * @interface OauthApiAppApiOauthAuthorizeRequest
 */
export interface OauthApiAppApiOauthAuthorizeRequest {
    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorize
     */
    readonly username: string

    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorize
     */
    readonly password: string

    /**
     * indicate token here
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorize
     */
    readonly response_type: string

    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorize
     */
    readonly client_id: string

    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorize
     */
    readonly redirect_uri: string

    /**
     * mfa token
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorize
     */
    readonly token?: string

    /**
     * user scope, either patient or reviewer
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorize
     */
    readonly user_scope?: string
}

/**
 * Request parameters for appApiOauthAuthorizeAuditorToken operation in OauthApi.
 * @export
 * @interface OauthApiAppApiOauthAuthorizeAuditorTokenRequest
 */
export interface OauthApiAppApiOauthAuthorizeAuditorTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeAuditorToken
     */
    readonly token?: string

    /**
     * indicate token here
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeAuditorToken
     */
    readonly response_type?: string

    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeAuditorToken
     */
    readonly client_id?: string

    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeAuditorToken
     */
    readonly redirect_uri?: string
}

/**
 * Request parameters for appApiOauthAuthorizeMagicLink operation in OauthApi.
 * @export
 * @interface OauthApiAppApiOauthAuthorizeMagicLinkRequest
 */
export interface OauthApiAppApiOauthAuthorizeMagicLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeMagicLink
     */
    readonly secure_token: string

    /**
     * indicate token here
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeMagicLink
     */
    readonly response_type: string

    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeMagicLink
     */
    readonly client_id: string

    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeMagicLink
     */
    readonly redirect_uri: string
}

/**
 * Request parameters for appApiOauthAuthorizeSwagger operation in OauthApi.
 * @export
 * @interface OauthApiAppApiOauthAuthorizeSwaggerRequest
 */
export interface OauthApiAppApiOauthAuthorizeSwaggerRequest {
    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeSwagger
     */
    readonly username: string

    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeSwagger
     */
    readonly password: string

    /**
     * indicate token here
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeSwagger
     */
    readonly response_type: string

    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeSwagger
     */
    readonly client_id: string

    /**
     * 
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeSwagger
     */
    readonly redirect_uri: string

    /**
     * mfa token
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeSwagger
     */
    readonly token?: string

    /**
     * user scope, either patient or reviewer
     * @type {string}
     * @memberof OauthApiAppApiOauthAuthorizeSwagger
     */
    readonly user_scope?: string
}

/**
 * OauthApi - object-oriented interface
 * @export
 * @class OauthApi
 * @extends {BaseAPI}
 */
export class OauthApi extends BaseAPI {
    /**
     * Unauthenticated and rate limited per client address and per email. Always returns 202 with an empty body for any email. The home region emails a login verification code to registered patients, a signup verification code to invited patients, or a generic no-account message otherwise. Canada forwards a US-home reservation to the US internal start endpoint and still returns 202 if that call fails. Account state is only revealed by POST /auth/email/verify. 
     * @summary Start verified email entry for login or signup
     * @param {OauthApiAppApiAuthEmailStartAuthEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public appApiAuthEmailStartAuthEmail(requestParameters: OauthApiAppApiAuthEmailStartAuthEmailRequest, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).appApiAuthEmailStartAuthEmail(requestParameters.AuthEmailStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unauthenticated and rate limited. On success returns whether the email is registered (continue to password / MFA) or invited (signup prefill). Wrong, expired, replaced, used, or locked codes return the same 400. Does not consume invited codes; POST /patients/onboarding does. Canada forwards a US-home reservation to the US internal verify endpoint and returns that body. A failed forward is the same 400 as a wrong code. 
     * @summary Verify emailed code and return account state
     * @param {OauthApiAppApiAuthEmailVerifyAuthEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public appApiAuthEmailVerifyAuthEmail(requestParameters: OauthApiAppApiAuthEmailVerifyAuthEmailRequest, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).appApiAuthEmailVerifyAuthEmail(requestParameters.AuthEmailVerifyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hash-only discovery hop for shared-app login. Clients send HMAC-SHA256 hex of the normalized email. A US reservation returns region=us. A miss returns region=ca. Never send raw email. Does not return a URL. 
     * @summary Discover API region from a peppered email hash
     * @param {OauthApiAppApiAuthRegionLookupRegionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public appApiAuthRegionLookupRegion(requestParameters: OauthApiAppApiAuthRegionLookupRegionRequest, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).appApiAuthRegionLookupRegion(requestParameters.AuthRegionLookupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a URL that authorizes a new third-party OAuth flow
     * @param {OauthApiAppApiExternalOauthGetAuthorizationUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public appApiExternalOauthGetAuthorizationUrl(requestParameters: OauthApiAppApiExternalOauthGetAuthorizationUrlRequest = {}, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).appApiExternalOauthGetAuthorizationUrl(requestParameters.provider_name, requestParameters.provider_endpoint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get auth token (with mfa support)
     * @param {OauthApiAppApiOauthAuthorizeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public appApiOauthAuthorize(requestParameters: OauthApiAppApiOauthAuthorizeRequest, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).appApiOauthAuthorize(requestParameters.username, requestParameters.password, requestParameters.response_type, requestParameters.client_id, requestParameters.redirect_uri, requestParameters.token, requestParameters.user_scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Temporary token for clinician <> auditor authentication
     * @param {OauthApiAppApiOauthAuthorizeAuditorTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public appApiOauthAuthorizeAuditorToken(requestParameters: OauthApiAppApiOauthAuthorizeAuditorTokenRequest = {}, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).appApiOauthAuthorizeAuditorToken(requestParameters.token, requestParameters.response_type, requestParameters.client_id, requestParameters.redirect_uri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get auth token using a secure token
     * @param {OauthApiAppApiOauthAuthorizeMagicLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public appApiOauthAuthorizeMagicLink(requestParameters: OauthApiAppApiOauthAuthorizeMagicLinkRequest, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).appApiOauthAuthorizeMagicLink(requestParameters.secure_token, requestParameters.response_type, requestParameters.client_id, requestParameters.redirect_uri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get auth token (to be used from swagger ui)
     * @param {OauthApiAppApiOauthAuthorizeSwaggerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public appApiOauthAuthorizeSwagger(requestParameters: OauthApiAppApiOauthAuthorizeSwaggerRequest, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).appApiOauthAuthorizeSwagger(requestParameters.username, requestParameters.password, requestParameters.response_type, requestParameters.client_id, requestParameters.redirect_uri, requestParameters.token, requestParameters.user_scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout and invalidate the current oauth token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public appApiOauthLogout(options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).appApiOauthLogout(options).then((request) => request(this.axios, this.basePath));
    }
}
